"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _helpers = require("../../../utils/helpers");
var _TwoColumnSlideModule = _interopRequireDefault(require("./../../../scss/carousels/slide-layouts/TwoColumnSlide.module.scss"));
function TwoColumnSlide(_ref) {
  let {
    columnOneContent,
    columnTwoContent
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_TwoColumnSlideModule.default['two-column-slide'], 'two-column-slide'])
  }, /*#__PURE__*/_react.default.createElement("column-one", null, typeof columnOneContent === 'string' ? (0, _htmlReactParser.default)(columnOneContent) : columnOneContent), /*#__PURE__*/_react.default.createElement("column-two", null, typeof columnTwoContent === 'string' ? (0, _htmlReactParser.default)(columnTwoContent) : columnTwoContent));
}
var _default = exports.default = TwoColumnSlide;